import axios from "axios";
import type { AxiosRequestConfig, AxiosResponse } from "axios";
import { Toast } from "antd-mobile";
import isString from "lodash/isString";
import useAppStore from "@/stores/useAppStore";
import { getErrorMessage } from "./getErrorMesaage";

const axiosInstance = axios.create({
  timeout: 1000 * 60,
  withCredentials: true,
});

// 请求拦截
axiosInstance.interceptors.request.use(
  (config) => {
    return config;
  },
  (err) => {
    return Promise.reject(err);
  },
);

// 响应拦截
axiosInstance.interceptors.response.use(
  (response) => {
    const result = response.data;

    if (!result.success) {
      const errorMessage = getErrorMessage(result?.code, result?.message);
      Toast.show({ icon: "fail", content: errorMessage });
    }

    return response;
  },
  (error) => {
    return error.response;
  },
);

/**
 * @description 获取请求地址
 */
const getRequestUrl = (config: AxiosRequestConfigPro) => {
  const { service } = config;

  if (process.env.NODE_ENV === "development") {
    return `/${service}${config.url}`;
  }

  switch (service) {
    case "oam-admin":
      return `${process.env.OAM_ADMIN_URL}${config.url}`;
  }
};

/**
 * @description 获取自定义header
 */
const getRequestHeaders = (config: AxiosRequestConfigPro) => {
  const { service } = config;

  const { token } = useAppStore.getState();

  if (service === "oam-admin" && isString(token)) {
    return { ["Oam-Token"]: token };
  }

  return {};
};

export interface ApiResponse<T> {
  code: string;
  success: boolean;
  message: string;
  model: T;
}

export interface Page<T> {
  amount: number;
  currentPage: number;
  nextPage: number;
  previousPage: number;
  totalPage: number;
  result: T[];
}

export interface AxiosRequestConfigPro extends AxiosRequestConfig {
  /**
   * @description 标识请求服务名,非axios配置
   */
  service: "oam-admin";
}

export const request = async <R>(
  config: AxiosRequestConfigPro,
): Promise<ApiResponse<R>> => {
  const { service, ...restConfig } = config;

  const requestConfig = {
    ...restConfig,
    url: getRequestUrl({ ...config, service }),
    headers: getRequestHeaders(config),
  };

  const response = await axiosInstance.request(requestConfig);

  return response?.data;
};

export const requestNative = async <R>(
  config: AxiosRequestConfigPro,
): Promise<AxiosResponse<ApiResponse<R>>> => {
  const { service, ...restConfig } = config;

  const requestConfig = {
    ...restConfig,
    url: getRequestUrl({ ...config, service }),
    headers: getRequestHeaders(config),
  };

  const response = await axiosInstance.request(requestConfig);

  return response;
};
